import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ADMIN_ROLES, STAFF_STATUSES } from "@/api/types";
import { TeamPage } from "@/features/team/team-page";
import { baseListSearch, optionalEnum } from "@/lib/list-state";

export const Route = createFileRoute("/_authenticated/team/")({
  validateSearch: z.object({
    ...baseListSearch,
    role: optionalEnum(ADMIN_ROLES),
    status: optionalEnum(STAFF_STATUSES),
  }),
  head: () => ({ meta: [{ title: "Team · Rogue Admin" }] }),
  component: TeamPage,
});
